import React from "react";
import { ExternalDirectiveResearch } from "./ExternalDirectiveResearch";

export const PressureEquipResearch = () => (
  <ExternalDirectiveResearch
    eurLexUrl="https://eur-lex.europa.eu/legal-content/EN/TXT/?uri=CELEX:32014L0068"
    i18nPrefix="steps.questionaire.pressureequip.research"
  />
);
